import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "number3CircleFilled"
const Number3CircleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M8.87 8.8H12.38L10.415 11.125V12.325C10.805 12.13 11.255 12.025 11.675 12.025 12.845 12.025 13.745 12.85 13.745 13.945 13.745 15.07 12.769 15.85 11.78 15.85 10.985 15.85 10.265 15.415 9.83 14.8L8.375 16.015C9.305 17.065 10.55 17.65 11.855 17.65 14.03 17.65 15.77 16.165 15.77 13.945 15.77 12.355 14.78 11.095 13.34 10.54L15.245 8.2V7H8.87z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default Number3CircleFilledIcon
